import { UploadedDocument } from '@urbanx/agx.agencies.client'
import { ApiRequestBody } from 'interfaces/ApiRequestBody'
import AgencyService from 'services/agenciesService'

interface UpdateBrandingRequest extends ApiRequestBody {
  AgencyName?: string
  BackgroundColor?: string
  BackgroundTextColor?: string
  AccentColorOld?: string
  ButtonTextColor?: string
  InboxBackgroundColor?: string
  InboxBackgroundColorOpacity?: string
  SidebarBackgroundColor?: string
  SidebarBackgroundColorOpacity?: string
  Logo?: UploadedDocument
  AgencyId?: string

  MainColour?: string
  AccentColour?: string
}

const UpdateBranding = async (
  requestBody: UpdateBrandingRequest
): Promise<number | undefined> => {
  const { getAuthToken, AgencyId, ...requestProperties } = requestBody

  if (!AgencyId) return

  const token = await getAuthToken()
  const service = new AgencyService(token)

  

  const result = await service.agencyService.put(
    `UpdateBranding?AgencyId=${AgencyId}`,
    { ...requestProperties }
  )

  return result.status
}

export default UpdateBranding
